import React from 'react';
import { VscClearAll } from 'react-icons/vsc';

const ClearFiltersButton = ({ show, onClick }) => {
  if (!show) return null;

  return (
    <div
      className="flex items-center self-stretch px-2 border rounded-md shadow-sm bg-white cursor-pointer text-gray-400 hover:text-gray-500"
      title="Clear"
      onClick={onClick}
    >
      <VscClearAll className="self-center size-6" />
    </div>
  );
};

export default ClearFiltersButton;
